<template>
  <v-container fluid class="fill-height">
    <v-row align-content="center" justify="center" style="height: 100%">
      <v-col cols="3">
        <v-alert color="primary" outlined icon="mdi-alert-circle">
          <span v-html="readableReason"></span>
        </v-alert>
      </v-col>
    </v-row>
    <v-footer app
              class="pa-0"
              height="25px"
              color="primary"
              style="line-height: 25px">
      <v-col style="height: 25px" class="py-0"></v-col>
      <v-col class="py-0"
             style="height: 25px">
        <v-row no-gutters align="center" justify="end">
        <span
          class="caption mr-1" style="opacity: 0.8; color: white">Powered by</span>
          <img @click="handleLinkout('https://geoxphere.com')"
               style="max-height: 25px; position: relative; right: 0px; cursor: pointer"
               src="https://geoxphere.com/images/LOGOS/poweredby/powered_by_geoxphere_white.png"/>
        </v-row>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
  export default {
    name: 'InvalidNotification',

    props: {
      reason: {
        type: String,
        default: ''
      },
      systype: {
        type: Array,
        default () {
          return []
        }
      }
    },

    methods: {
      handleLinkout (url){
        window.open(url, '_blank')
      }
    },

    computed: {
      productName () {
        if (this.systype[0].indexOf('parishonline') > -1){
          return `<a href="https://www.parish-online.co.uk/" target="_blank">Parish Online</a>`
        }

        return 'XMAP';
      },
      readableReason() {
        switch (this.reason) {
          case '':
            return 'Invalid Map';
            break;
          case 'invalid_id':
            return 'Map ID not recognised';
            break;
          case 'inactive_account':
            return `${this.productName} subscription expired.`;
            break;
        }
      }
    }
  };
</script>

<style scoped>

</style>
